import { AlertTriangle, Zap, Clock, ChevronRight } from "lucide-react";

const lvClass = (lv) => {
  const l = (lv || "").toUpperCase();
  if (l === "CRITICAL") return "lv-critical";
  if (l === "APPROVAL_REQUIRED") return "lv-approval";
  return "";
};

const refDecision = (ref) =>
  (ref && (ref.decision_id || ref.decisionId)) || null;

// LEFT — Founder Attention Engine + décisions/événements récents (cross-link → X-Ray).
export default function AttentionRail({ attention, recentDecisions, onPickDecision }) {
  const top = attention?.top;
  const inbox = attention?.inbox || [];
  const topItems = top?.top || [];

  return (
    <section className="ck-panel" data-testid="ck-attention">
      <div className="ck-panel__head">
        <h2>Founder Attention</h2>
        <span className="sub">ce qui mérite mon attention</span>
      </div>
      <div className="ck-panel__body">
        <div className="rail-group">
          <div className="rail-title">Top impact réel</div>
          {topItems.length === 0 && (
            <div className="rail-empty" data-testid="attention-top-empty">
              {top?.note || "Pas assez de signaux exploitables."}
            </div>
          )}
          {topItems.slice(0, 4).map((t) => (
            <div key={t.id} className="rail-item" data-testid={`attention-top-${t.id}`}>
              <div className="rail-item__t"><Zap size={12} style={{ color: "#f59e0b", verticalAlign: "-1px", marginRight: 5 }} />{t.title}</div>
              <div className="rail-item__b">{t.proposal || t.type}</div>
              <div className="rail-item__meta">
                <span className="mono">prio {t.priority_score ?? "—"}</span>
                {t.impact?.basis && <span>{t.impact.basis}{t.impact.value != null ? ` · ${t.impact.value}${t.impact.unit || ""}` : ""}</span>}
              </div>
            </div>
          ))}
        </div>

        <div className="rail-group">
          <div className="rail-title">Signaux spontanés</div>
          {inbox.length === 0 && <div className="rail-empty">Aucun signal en attente.</div>}
          {inbox.slice(0, 6).map((n) => {
            const did = refDecision(n.ref);
            return (
              <div key={n.id} className={"rail-item " + lvClass(n.level)}
                onClick={() => did && onPickDecision(did)} data-testid={`attention-inbox-${n.id}`}>
                <div className="rail-item__t">
                  {n.level === "CRITICAL" && <AlertTriangle size={12} style={{ color: "#f4544c", verticalAlign: "-1px", marginRight: 5 }} />}
                  {n.title}
                </div>
                {n.body && <div className="rail-item__b">{n.body}</div>}
                <div className="rail-item__meta">
                  <span className="mono">{(n.created_at || "").slice(0, 16).replace("T", " ")}</span>
                  {did && <span style={{ color: "#22d3ee" }}>voir décision →</span>}
                </div>
              </div>
            );
          })}
        </div>

        <div className="rail-group">
          <div className="rail-title">Décisions récentes</div>
          {(recentDecisions || []).length === 0 && <div className="rail-empty" data-testid="recent-decisions-empty">Aucune décision enregistrée.</div>}
          {(recentDecisions || []).slice(0, 12).map((d) => (
            <div key={d.decision_id} className={"rail-item" + (d.is_shadow ? " lv-shadow" : "")}
              onClick={() => onPickDecision(d.decision_id)} data-testid={`recent-decision-${d.decision_id}`}>
              <div className="rail-item__t" style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{d.is_shadow ? "SHADOW" : (d.cohort || d.qualification || "décision")}</span>
                <ChevronRight size={14} style={{ color: "#778698" }} />
              </div>
              <div className="rail-item__meta">
                <Clock size={11} style={{ verticalAlign: "-1px" }} />
                <span className="mono">{(d.at || "").slice(0, 19).replace("T", " ")}</span>
              </div>
              <div className="rail-item__meta">
                <span className="mono">km {d.planned_distance_km ?? "?"}→{d.actual_distance_km ?? "?"}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
